export default {
  'form.entityInfo': '{{entity}}-Informationen',
  'form.required': '{{field}} ist erforderlich',
  'form.inputPlaceholder': '{{field}} eingeben',
  'form.selectPlaceholder': '{{field}} auswählen',
  'form.invalidLayout': 'Nicht kompatibles Layout',
  'form.cloneFrom': 'Klonen von {{instance}}',
  'form.image': '{{type}} Bild',
  'form.image.filename': 'Bildname',
  'form.image.altText': 'Alternativtext des Bildes',
  'form.fullName': 'Vollständiger Name',
  'form.firstName': 'Vorname',
  'form.lastName': 'Nachname',
  'form.middleName': 'Zweiter Vorname',
  'form.honorificName': 'Anrede',
  'form.birthdate': 'Geburtsdatum',
  'form.genderIdentity': 'Geschlechtsidentität',
  'form.entity': 'Entität',
  'form.entityKey': 'Entitätsschlüssel',
  'form.contentKey': 'Inhaltsschlüssel',
  'form.upload': 'Hochladen',
  'form.selectFile': 'Datei auswählen',
  'form.uploadText': 'Klicken oder Datei zum Hochladen hierher ziehen',
  'form.uploadHint':
    'Einzel- oder Mehrfach-Upload unterstützt. Das Hochladen von Unternehmensdaten oder anderen sensiblen Dateien ist strikt untersagt',
  'form.uploadTypeError': '{name} ist kein gültiger Dateityp',
  'form.uploadDimsError':
    'Maximale Bildabmessungen (Breite x Höhe) {width}px x {height}px',
  'form.translate': 'Schlüssel übersetzen',
  'form.helper': 'Hilfe anzeigen',
  'form.license': 'Lizenz',
  'form.license.type': 'Lizenztyp',
  'form.license.number': 'Lizenz-ID',
  'form.licenses': 'Lizenzen',
  'form.title': 'Titel',
  'form.number': 'Nummer',
  'form.description': 'Beschreibung',
  'form.shortDescription': 'Kurzbeschreibung',
  'form.status': 'Status',
  'form.tags': 'Tags',
  'form.target': 'Ziel',
  'form.link': 'Link-Adresse',
  'form.logo': 'Logo',
  'form.logos': 'Logos',
  'form.logo.primary': 'Primäres Logo',
  'form.email.type': 'E-Mail-Typ',
  'form.email': 'E-Mail-Adresse',
  'form.emails': 'E-Mail-Adressen',
  'form.countryCode': 'Ländercode',
  'form.phone': 'Telefonnummer',
  'form.phones': 'Telefonnummern',
  'form.phone.type': 'Gerätetyp',
  'form.phone.businessType': 'Geschäftlich',
  'form.phone.ability': 'Telefontyp',
  'form.phone.extension': 'Durchwahl',
  'form.email.primary': 'Primäre E-Mail-Adresse',
  'form.email.primary.description':
    'wird für kontobezogene Benachrichtigungen und Passwort-Resets verwendet.',
  'form.private.helper':
    'Private {{type}} können nicht als öffentliche primäre {{type}} im System festgelegt werden',
  'form.billing.helper':
    'Private {{type}} können nicht als öffentliche Abrechnungs-{{type}} im System festgelegt werden',
  'form.unverified.helper':
    'Unbestätigte {{type}} können nicht als öffentliche primäre {{type}} im System festgelegt werden',
  'form.phone.primary': 'Primäre Telefonnummer',
  'form.phone.primary.description': 'wird für kontobezogene Anrufe verwendet.',
  'form.email.exists': 'E-Mail-Adresse existiert bereits',
  'form.phone.exists': 'Telefonnummer existiert bereits',
  'form.preview': 'Vorschau',
  'form.documentUrl': 'Dokument-URL',
  'form.imgUrl': 'Bild-URL',
  'form.embedUrl': 'Einbettungs-URL',
  'form.ownerName': 'Name des Eigentümers',
  'form.issueDate': 'Ausstellungsdatum',
  'form.expirationDate': 'Ablaufdatum',
  'form.renewalDate': 'Erneuerungsdatum',
  'form.createdBy': 'Erstellt von',
  'form.updatedBy': 'Aktualisiert von',
  'form.createdAt': 'Erstellt am',
  'form.lastUsed': 'Zuletzt verwendet',
  'form.updatedAt': 'Aktualisiert am',
  'form.invitedAt': 'Eingeladen am',
  'form.today': 'Heute',
  'form.tomorrow': 'Morgen',
  'form.days': '{{count}} Tage',
  'form.customize': 'Anpassen',
  'form.noExpiration': 'Kein Ablauf',
  'form.nameHelp':
    'Ihr {{type}} kann bei WelcomeHome erscheinen, wo Sie beitragen oder erwähnt werden.',
  'form.type.public': 'Öffentlich',
  'form.type.primary': 'Primär',
  'form.type.draft': 'Entwurf',
  'form.type.private': 'Privat',
  'form.type.minor': 'Nebensächlich',
  'form.assets': 'Assets ({{amount}})',
  'form.validation.min': '{{entity}} muss mindestens {min} Zeichen enthalten',
  'form.metadata': 'Metadaten',
  'form.section': 'Abschnitt',
  'form.private': 'Privat',
  'form.public': 'Öffentlich',
  'form.source': 'Quelle',
  'form.switch.yes': 'Ja',
  'form.switch.no': 'Nein',
  'form.phone.invalidPhone': 'Ungültige Telefonnummer',
  'form.phone.countryCode': 'Ländercode',
  'form.approve': 'Genehmigen',
  'form.toHide': 'ausblenden',
  'form.toShow': 'anzeigen',
  'form.confirm': 'Bestätigen',
  'form.name': '{{entity}}-Name',
  'form.type': 'Typ',
  'form.typeOf': '{{entity}}-Typ',
  'form.verify': '{{type}} bestätigen',
  'form.enterField': '{{type}} hier eingeben',
  'form.tag.helper':
    'Schlüsselwörter hinzufügen zur Kategorisierung oder Identifikation der Funktion',
  'form.metadata.helper':
    'Systemgenerierte Informationen: wer diesen Eintrag erstellt oder zuletzt aktualisiert hat und wann',

  'form.credits.modal.title': 'Guthaben vergeben',
  'form.credits.modal.ok': 'Vergeben',
  'form.credits.tenant': 'Mandant',
  'form.credits.tenant.tooltip':
    'Der Mandant (Organisation), dessen Wallet gutgeschrieben wird.',
  'form.credits.tenant.placeholder': 'Mandant auswählen',
  'form.credits.tenant.noTenants': 'Keine Mandanten gefunden.',
  'form.credits.tenant.createLink': 'Zuerst einen Mandanten erstellen',
  'form.credits.userId': 'Benutzer-ID',
  'form.credits.userId.tooltip':
    'Der Benutzer, dessen Wallet die Gutschrift erhält. Standardmäßig Ihre UID — ändern Sie dies, um einem anderen Benutzer Guthaben zu vergeben.',
  'form.credits.userId.extra':
    'Vorausgefüllt mit Ihrer UID. Bearbeiten Sie, um einen anderen Empfänger anzugeben.',
  'form.credits.userId.placeholder': 'Firebase UID des Empfängers',
  'form.credits.amount': 'Betrag',
  'form.credits.amount.tooltip':
    'Anzahl der zu vergebenden Guthaben. Muss eine positive ganze Zahl sein.',
  'form.credits.kind': 'Art',
  'form.credits.kind.tooltip':
    'GRANT fügt Guthaben hinzu; DEBIT entfernt es; REFUND gibt zuvor abgebuchte Guthaben zurück.',
  'form.credits.kind.grant': 'GRANT — Guthaben zum Wallet hinzufügen',
  'form.credits.kind.debit': 'DEBIT — Guthaben vom Wallet abziehen',
  'form.credits.kind.refund': 'REFUND — Abgebuchte Guthaben zurückgeben',
  'form.credits.kind.adjustment': 'ADJUSTMENT — manuelle Saldokorrektur',
  'form.credits.referenceId': 'Referenz-ID',
  'form.credits.referenceId.tooltip':
    'Externe Referenz zur Nachverfolgung — z.B. Rechnungs-ID, Bestell-ID oder Support-Ticket-Nummer.',
  'form.credits.referenceId.extra':
    'Verwenden Sie eine aussagekräftige externe ID (Rechnung, Bestellung, Ticket).',
  'form.credits.referenceId.placeholder': 'z.B. INV-2024-001',
  'form.credits.operation': 'Vorgang',

  'form.entitlements.operation': 'Vorgang',
  'form.entitlements.kind': 'Art',
  'form.entitlements.costPerUnit': 'Kosten / Einheit',
  'form.entitlements.version': 'Version',
  'form.entitlements.isActive': 'Aktiv',

  'form.subscription.monthlyCredits': 'Monatliche Credits',
};
